import { api } from '../../../AxiosConfig';

class GoogleCalendarService {
    getStatus() {
        return api.get('/integrations/google-calendar/status');
    }

    getAuthUrl() {
        return api.get('/integrations/google-calendar/auth-url');
    }

    connect(code: string) {
        return api.post('/integrations/google-calendar/callback', { code });
    }

    disconnect() {
        return api.post('/integrations/google-calendar/disconnect');
    }
}

export { GoogleCalendarService };
